<template>
    <PowerDataBase :selectedLoops="selectedLoops" :real-data="realData" :options="options" :current-loop="currentLoop">
        <div class="row-center transformer" style="justify-content: flex-start"
            v-if="this.$route.params.name === 'Transformer'">
            <div>
                <span class="k">额定容量：</span>
                <span class="v">123kVA</span>
            </div>
            <div>
                <span class="k">负荷率：</span>
                <span class="v">12.3%</span>
            </div>
        </div>

        <div class="row-center breaker" style="justify-content: flex-start"
            v-if="this.$route.params.name === 'Breaker'">
            <div>
                <span class="k">分合状态：</span>
                <span class="v">合闸</span>
            </div>
            <div class="sate">
                <span class="k">手车位置：</span>
                <span class="Handcart">工作</span>
            </div>
        </div>
    </PowerDataBase>
    
</template>

<script>
    import Curve from "../../chart/Curve";
    import PowerDataBase from "./PowerDataBase";

    export default {
        name: "PowerData",
        components: {
            Curve,
            PowerDataBase
        },
        props: {
            currentLoop: Object,
            selectedLoops: Array
        },
        computed: {
            options() {

                if (this.routeName === 'Transformer') {
                    return [{
                            value: '1-2',
                            label: '负载监测'
                        },
                        {
                            value: '1-0',
                            label: '三相温度'
                        },
                    ]
                }

                if (this.routeName === 'PowerQuality') {
                    return this.realData.map((d, index) => {
                        return {
                            value: index + '-0',
                            label: d.type
                        }
                    })
                }
             
                    return [{
                            value: '0-0',
                            label: '功率因数'
                        },
                        {
                            value: '0-1',
                            label: '有功功率'
                        },
                        {
                            value: '0-2',
                            label: '无功功率'
                        },
                        {
                            value: '0-3',
                            label: '视在功率'
                        },
                        {
                            value: '1-0',
                            label: '三相相电压'
                        },
                        {
                            value: '1-1',
                            label: '三相线电压'
                        },
                        {
                            value: '1-2',
                            label: '三相电流'
                        },
                        {
                            value: '2-0',
                            label: '母排温度'
                        },
                    ]

            },
            tag() {
                return this.$route.params.tag
            },
            routeName() {
                return this.$route.params.name
            },
            realData() {

                if (this.routeName === 'Transformer') {
                    return [{},
                        {
                            type: "",
                            details: [{
                                    key: "三相温度",
                                    unit: "℃",
                                    data: {
                                        'A': "Temperature_A",
                                        'B': "Temperature_B",
                                        'C': "Temperature_C",
                                        '环境温度': "Temperature",
                                    }
                                },
                                {},
                                {
                                    key: "负载监测",
                                    unit: "kW",
                                    multiple: 0.001,
                                    data: {
                                        "负载监测": "P",
                                    },
                                },

                            ]
                        },
                    ]
                }
                if (this.routeName === 'Breaker') {
                    return [{
                            type: "功率",
                            details: [{
                                    key: "功率因数",
                                    unit: "",
                                    data: {
                                        A: "PFa",
                                        B: "PFb",
                                        C: "PFc",
                                        总: "PF",
                                    }
                                },
                                {
                                    key: "有功功率",
                                    unit: "kW",
                                    multiple: 0.001,
                                    data: {
                                        A: "Pa",
                                        B: "Pb",
                                        C: "Pc",
                                        总: "P",
                                       
                                    }
                                },
                                {
                                    key: "无功功率",
                                    unit: "kVar",
                                    multiple: 0.001,
                                    data: {
                                        A: "PRa",
                                        B: "PRb",
                                        C: "PRc",
                                        总: "PR",
                                    },
                                },
                                {
                                    key: "视在功率",
                                    unit: "kVA",
                                    multiple: 0.001,
                                    data: { 
                                        A: "PAa",
                                        B: "PAb",
                                        C: "PAc",
                                        总: "PA",
                                    }
                                },

                            ]
                        },
                        {
                            type: "电压、电流",
                            details: [{
                                    key: "三相相电压",
                                    unit: "V",
                                    data: {
                                        A: "Ua",
                                        B: "Ub",
                                        C: "Uc",
                                    }
                                },
                                {
                                    key: "三相线电压",
                                    unit: "V",
                                    data: {
                                        A: "Uab",
                                        B: "Ubc",
                                        C: "Uac",
                                    }
                                },
                                {
                                    key: "三相电流",
                                    unit: "A",
                                    data: {
                                        A: "Ia",
                                        B: "Ib",
                                        C: "Ic",
                                    }
                                },
                            ]
                        },
                        {
                            type: "触头温度",
                            details: [{
                                    key: "触头温度",
                                    unit: "℃",
                                    data: {
                                        A: "temperature_upper_a",
                                        B: "temperature_upper_b",
                                        C: "temperature_upper_c",
                                    }
                                }

                            ]
                        },

                    ]
                }

                if (this.routeName === 'PowerQuality') {
                    return [

                        {
                            type: "电压总谐波",
                            details: [{
                                    key: "",
                                    unit: "%",
                                    data: {
                                        "A": "THD_Ua",
                                        "B": "THD_Ub",
                                        "C": "THD_Uc",
                                    }
                                },

                            ]
                        },
                        {
                            type: "电流总谐波",
                            details: [{
                                    key: "",
                                    unit: "%",
                                    data: {
                                        "A": "THD_Ia",
                                        "B": "THD_Ib",
                                        "C": "THD_Ic",
                                    }
                                },

                            ]
                        },
                        // {
                        // 						type: "三相相电压不平衡度",
                        // 						details: [
                        // 							{
                        // 								key: "",
                        // 								unit: "%",
                        // 								data: {
                        // 									"不平衡度": "U_unbl",
                        // 								}
                        // 							}
                        // 						]
                        // 					},
                        // 					{
                        // 						type: "三相电流不平衡度",
                        // 						details: [
                        // 							{
                        // 								key: "",
                        // 								unit: "%",
                        // 								data: {
                        // 									"不平衡度": "I_unbl",
                        // 								}
                        // 							},
                        // 						]
                        // 					},

                        ...this.createData()

                    ]
                }

               
                    if (this.currentLoop.uniaxial) {
                        return [{
                                type: "功率",
                                details: [{
                                        key: "功率因数",
                                        unit: "",
                                        data: {
                                            A: "PFa",
                                            B: "PFb",
                                            C: "PFc",
                                            总: "PF",
                                        }
                                    },
                                    {
                                        key: "有功功率",
                                        unit: "kW",
                                        // 这个属性，计算的时候会乘进去 0.001 就是除以1000
                                        //multiple: 0.001,
                                        multiple: 0.001,
                                        data: {
                                            A: "Pa",
                                            B: "Pb",
                                            C: "Pc",
                                            总: "P",
                                            
                                        }
                                    },
                                    {
                                        key: "无功功率",
                                        unit: "kVar",
                                        multiple: 0.001,
                                        data: {
                                            A: "PRa",
                                            B: "PRb",
                                            C: "PRc",
                                            总: "PR",
                                        }
                                    },
                                    {
                                        key: "视在功率",
                                        unit: "kVA",
                                        multiple: 0.001,
                                        data: {
                                            A: "PAa",
                                            B: "PAb",
                                            C: "PAc",
                                            总: "PA",
                                        }
                                    },

                                ]
                            },
                            {
                                type: "电压、电流",
                                details: [{
                                        key: "三相相电压",
                                        unit: "V",
                                        data: {
                                            A: "Ua",
                                            B: "Ub",
                                            C: "Uc",
                                        }
                                    },
                                    {
                                        key: "三相线电压",
                                        unit: "V",
                                        data: {
                                            A: "Uab",
                                            B: "Ubc",
                                            C: "Uac",
                                        }
                                    },
                                    {
                                        key: "三相电流",
                                        unit: "A",
                                        data: {
                                            'A': "Ia",
                                            'B': "Ib",
                                            'C': "Ic",
                                        }
                                    },
                                ]
                            },
                            {
                                type: "温度",
                                details: [{
                                    key: "母排温度",
                                    unit: "℃",
                                    data: {
                                        A: "Temperature_A",
                                        B: "Temperature_B",
                                        C: "Temperature_C"
                                    }
                                }
                                ]
                            },
                        ]
                    } else if (this.currentLoop.busbarTemperature == 1) {
                        return [{
                                type: "功率",
                                details: [{
                                        key: "功率因数",
                                        unit: "",
                                        data: {
                                            A: "PFa",
                                            B: "PFb",
                                            C: "PFc",
                                            总: "PF",
                                        }
                                    },
                                    {
                                        key: "有功功率",
                                        unit: "kW",
                                        // 这个属性，计算的时候会乘进去 0.001 就是除以1000
                                        //multiple: 0.001,
                                        multiple: 0.001,
                                        data: {
                                            A: "Pa",
                                            B: "Pb",
                                            C: "Pc",
                                            总: "P",
                                        }
                                    },
                                    {
                                        key: "无功功率",
                                        unit: "kVar",
                                        multiple: 0.001,
                                        data: {
                                            A: "PRa",
                                            B: "PRb",
                                            C: "PRc",
                                            总: "PR",
                                        }
                                    },
                                    {
                                        key: "视在功率",
                                        unit: "kVA",
                                        multiple: 0.001,
                                        data: {
                                            A: "PAa",
                                            B: "PAb",
                                            C: "PAc",
                                            总: "PA",
                                        }
                                    },

                                ]
                            },
                            {
                                type: "电压、电流",
                                details: [{
                                        key: "三相相电压",
                                        unit: "V",
                                        data: {
                                            A: "Ua",
                                            B: "Ub",
                                            C: "Uc",
                                        }
                                    },
                                    {
                                        key: "三相线电压",
                                        unit: "V",
                                        data: {
                                            A: "Uab",
                                            B: "Ubc",
                                            C: "Uac",
                                        }
                                    },
                                    {
                                        key: "三相电流",
                                        unit: "A",
                                        data: {
                                            'A': "Ia",
                                            'B': "Ib",
                                            'C': "Ic",
                                        }
                                    },
                                ]
                            },
                            {
                                type: "温度",
                                details: [{
                                        key: "进线母排温度",
                                        unit: "℃",
                                        data: {
                                            A: "Temperature_in_A",
                                            B: "Temperature_in_B",
                                            C: "Temperature_in_C"
                                        }
                                    }, {
                                        key: "出线母排温度",
                                        unit: "℃",
                                        data: {
                                            A: "Temperature_out_A",
                                            B: "Temperature_out_B",
                                            C: "Temperature_out_C"
                                        }
                                    }

                                ]
                            },
                        ]
                    } else {

                        if (this.routeName === "protect1") {
                            return [{
                                    type: "功率",
                                    details: [{
                                            key: "功率因数",
                                            unit: "",
                                            data: {
                                                A: "PFa",
                                                B: "PFb",
                                                C: "PFc",
                                                总: "PF",
                                            }
                                        },
                                        {
                                            key: "有功功率",
                                            unit: "kW",
                                            // 这个属性，计算的时候会乘进去 0.001 就是除以1000
                                            //multiple: 0.001,
                                            multiple: 0.001,
                                            data: {
                                                A: "Pa",
                                                B: "Pb",
                                                C: "Pc",
                                                总: "P",
                                                
                                            }
                                        },
                                        {
                                            key: "无功功率",
                                            unit: "kVar",
                                            multiple: 0.001,
                                            data: {
                                                A: "PRa",
                                                B: "PRb",
                                                C: "PRc",
                                                总: "PR",
                                            }
                                        },
                                        {
                                            key: "视在功率",
                                            unit: "kVA",
                                            multiple: 0.001,
                                            data: {
                                                A: "PAa",
                                                B: "PAb",
                                                C: "PAc",
                                                总: "PA",
                                            }
                                        },

                                    ]
                                },
                                {
                                    type: "电压、电流",
                                    details: [{
                                            key: "三相相电压",
                                            unit: "V",
                                            data: {
                                                A: "Ua",
                                                B: "Ub",
                                                C: "Uc",
                                            }
                                        },
                                        {
                                            key: "三相线电压",
                                            unit: "V",
                                            data: {
                                                A: "Uab",
                                                B: "Ubc",
                                                C: "Uac",
                                            }
                                        },
                                        {
                                            key: "三相电流",
                                            unit: "A",
                                            data: {
                                                A: "I1a",
                                                B: "I1b",
                                                C: "I1c",
                                            }
                                        },
                                    ]
                                },

                            ]
                        } else {
                            return [{
                                    type: "功率",
                                    details: [{
                                            key: "功率因数",
                                            unit: "",
                                            data: {
                                                A: "PFa",
                                                B: "PFb",
                                                C: "PFc",
                                                总: "PF",
                                            }
                                        },
                                        {
                                            key: "有功功率",
                                            unit: "kW",
                                            // 这个属性，计算的时候会乘进去 0.001 就是除以1000
                                            //multiple: 0.001,
                                            multiple: 0.001,
                                            data: {
                                                A: "Pa",
                                                B: "Pb",
                                                C: "Pc",
                                                总: "P",
                                            }
                                        },
                                        {
                                            key: "无功功率",
                                            unit: "kVar",
                                            multiple: 0.001,
                                            data: {
                                                A: "PRa",
                                                B: "PRb",
                                                C: "PRc",
                                                总: "PR",
                                            }
                                        },
                                        {
                                            key: "视在功率",
                                            unit: "kVA",
                                            multiple: 0.001,
                                            data: {
                                                A: "PAa",
                                                B: "PAb",
                                                C: "PAc",
                                                总: "PA",
                                                
                                            }
                                        },

                                    ]
                                },
                                {
                                    type: "电压、电流",
                                    details: [{
                                            key: "三相相电压",
                                            unit: this.currentLoop.loopId=='1270'||this.currentLoop.loopId=='1269'||this.currentLoop.loopId=='1268'||this.currentLoop.loopId=='1265'||this.currentLoop.loopId=='1266'||this.currentLoop.loopId=='1193'?'kV':"V",
                                            data: {
                                                A: "Ua",
                                                B: "Ub",
                                                C: "Uc",
                                            },
                                            data1: {
                                                A: "Uab",
                                                B: "Ubc",
                                                C: "Uac",
                                            }
                                        },
                                        {
                                            key: "三相线电压",
                                            unit:this.currentLoop.loopId=='1270'||this.currentLoop.loopId=='1269'||this.currentLoop.loopId=='1268'||this.currentLoop.loopId=='1265'||this.currentLoop.loopId=='1266'||this.currentLoop.loopId=='1193'?'kV':"V",
                                            data: {
                                                A: "Uab",
                                                B: "Ubc",
                                                C: "Uac",
                                            }
                                        },
                                        {
                                            key: "三相电流",
                                            unit: "A",
                                            data: {
                                                'A': "Ia",
                                                'B': "Ib",
                                                'C': "Ic",
                                            }
                                        },
                                    ]
                                },
                                {
                                    type: "温度",
                                    details: [{
                                            key: "母排温度",
                                            unit: "℃",
                                            data: {
                                                A: "Temperature_A",
                                                B: "Temperature_B",
                                                C: "Temperature_C"
                                            }
                                        }

                                    ]
                                },
                            ]
                        }
                    }
            }
        },
        data() {
            return {
                node: "",

                date: new Date(),
                diagramSelected: 0,

            }
        },
        methods: {
            createData() {
                let res = []
               
                    for (let i = 2; i <= 31; i++) {
                        res.push({
                            type: `电压${i}次谐波`,
                            details: [{
                                    key: "",
                                    unit: "%",
                                    data: {
                                        "A": `HUa${i}`,
                                        "B": `HUb${i}`,
                                        "C": `HUc${i}`,
                                    }
                                },

                            ]
                        }, {
                            type: `电流${i}次谐波`,
                            details: [{
                                key: "",
                                unit: "%",
                                data: {
                                    "A": `HIa${i}`,
                                    "B": `HIb${i}`,
                                    "C": `HIc${i}`,
                                }
                            }, ]
                        }, )
                    }

                return res
            }
        }
    }
</script>

<style scoped lang="less">
    .transformer {
        width: 100%;
        height: 100%;

        span {
            font-size: 18rem;
            font-weight: bold;
        }

        >div {
            margin-right: 72rem;
        }

        .k {
            color: #333333;
            margin-right: 18rem;
        }

        .v {
            color: #0D94FF;
        }
    }

    .breaker {
        width: 100%;
        height: 100%;
        // background-color: rgba(0, 43, 102, 0.04);
        padding-left: 8rem;

        span {
            font-size: 18rem;
            font-weight: bold;
        }

        .k {
            color: #333333;
            margin-right: 24rem;
        }

        .v {
            color: red;
            ;
        }

        .Handcart {
            color: #0D94FF;
        }

        .sate {
            padding-left: 325rem;
        }
    }
</style>